import React from "react";
import { View, Text } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";

const NoChatFound: React.FC = () => (
  <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
    <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>Start Chatting</Text>
  </View>
);

export default withErrorBoundary(NoChatFound);
